<template>
    <header class="bg-gray-900">
        <h1 class="text-xl text-white font-semi text-center p-4 ">
            <a href="/" class="flex items-center justify-center">
                <img src="@/img/logo.png" alt="Trivia Quiz logo" class="w-6 mr-2">
                <h1>Trivia Quiz</h1>
            </a>
        </h1>
    </header>
</template>